// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_wrapper {
  width: 100%;  
  background: #100F0F;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer_main_container {
  max-width: 1500px;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 40px 0 40px 100px;
}

.footer_left {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.footer_logo {
  width: 300px;
  height: 100px;
  object-fit: contain;
  object-position: top;
  filter: invert(100%);
}

.footer_right {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 0 0 100px;
}

.footer_card {
  width: 220px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 30px;
}

.footer_card_heading_div {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.footer_card_heading_div > p {
  color: #fff;
  font-family: "Roboto";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 15px;
}

.footer_card_main_div > ul {
    display: flex;
    flex-direction: column;
}

.footer_link {
  list-style: none;
  margin-top: 12px;

  color: #fff;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.footer_social_icons {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.footer_social_icon {
  width: 40px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}










@media screen and (max-width: 1200px) {
 
  .footer_main_container {
    max-width: 100%;
    flex-direction: row;
    padding: 40px 0 40px 50px;
  }
  
  .footer_left {
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .footer_logo {
    width: 300px;
    height: 50px;
  }
  
  .footer_right {
      flex-direction: row;
      padding: 0 0 0 100px;
  }
  
  .footer_card {
    width: 180px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 30px 40px 0;
  }
  
  .footer_card_heading_div {
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .footer_card_heading_div > p {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .footer_card_main_div > ul {
      flex-direction: column;
  }
  
  .footer_link {
    margin-top: 12px;
    font-size: 16px;
  }

}














@media screen and (max-width: 1024px) {
 
  .footer_main_container {
    max-width: 100%;
    flex-direction: row;
    padding: 40px 0 40px 20px;
  }
  
  .footer_left {
    display: none;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .footer_logo {
    width: 300px;
    height: 50px;
  }
  
  .footer_right {
      flex-direction: row;
      padding: 0 0 0 70px;
  }
  
  .footer_card {
    width: 180px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 30px 40px 0;
  }
  
  .footer_card_heading_div {
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .footer_card_heading_div > p {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .footer_card_main_div > ul {
      flex-direction: column;
  }
  
  .footer_link {
    margin-top: 12px;
    font-size: 16px;
  }

}













@media screen and (max-width: 800px) {
 
  .footer_main_container {
    max-width: 100%;
    flex-direction: column;
    padding: 40px 0 0px 20px;
  }
  
  /* .footer_left {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }
  
  .footer_logo {
    width: 300px;
    height: 50px;
  } */
  
  .footer_right {
      flex-direction: row;
      padding: 0 0 0 30px;
  }
  
  .footer_card {
    width: 180px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 30px 40px 0;
  }
  
  .footer_card_heading_div {
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .footer_card_heading_div > p {
    font-size: 18px;
    margin-bottom: 15px;
  }
  
  .footer_card_main_div > ul {
      flex-direction: column;
  }
  
  .footer_link {
    margin-top: 12px;
    font-size: 16px;
  }
  
  .footer_social_icon {
    width: 35px;
    height: 35px;
  }

}












@media screen and (max-width: 600px) {

  .footer_wrapper {
    margin-top: 30px;
  }
 
  .footer_main_container {
    max-width: 100%;
    flex-direction: column;
    padding: 20px 0 0px 20px;
  }
  
  /* .footer_left {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .footer_logo {
    width: 300px;
    height: 50px;
  } */
  
  .footer_right {
      flex-direction: row;
      padding: 0 0 20px 0;
      flex-wrap: wrap;
  }
  
  .footer_card {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 0px 20px 0;
  }
  
  .footer_card_heading_div {
    align-items: flex-start;
    justify-content: flex-start;
  }
  
  .footer_card_heading_div > p {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .footer_card_main_div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .footer_card_main_div > ul {
      flex-direction: row;
      flex-wrap: wrap;
  }
  
  .footer_link {
    width: auto;
    margin-top: 8px;
    font-size: 14px;
    padding: 0 10px 0 0;
    margin: 0 10px 5px 0;
    border-right: 1px solid black;
    word-break:keep-all;
  }

  .footer_link:last-child {
    border-right: none;
  }
  
  .footer_social_icon {
    width: 30px;
    height: 30px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/common/footer/footer.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EAEpB,oBAAoB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;;EAEhB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;;;;;;;;;AAWA;;EAEE;IACE,eAAe;IACf,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;MACI,mBAAmB;MACnB,oBAAoB;EACxB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;;AAeA;;EAEE;IACE,eAAe;IACf,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;MACI,mBAAmB;MACnB,mBAAmB;EACvB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;AAcA;;EAEE;IACE,eAAe;IACf,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;;;;;;;;;;;KAWG;;EAEH;MACI,mBAAmB;MACnB,mBAAmB;EACvB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;;;;;;;;;;;KAWG;;EAEH;MACI,mBAAmB;MACnB,mBAAmB;MACnB,eAAe;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;MACI,mBAAmB;MACnB,eAAe;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.footer_wrapper {\n  width: 100%;  \n  background: #100F0F;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.footer_main_container {\n  max-width: 1500px;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  padding: 40px 0 40px 100px;\n}\n\n.footer_left {\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.footer_logo {\n  width: 300px;\n  height: 100px;\n  object-fit: contain;\n  object-position: top;\n  -webkit-filter: invert(100%);\n  filter: invert(100%);\n}\n\n.footer_right {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 0 0 0 100px;\n}\n\n.footer_card {\n  width: 220px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 0 30px;\n}\n\n.footer_card_heading_div {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.footer_card_heading_div > p {\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-bottom: 15px;\n}\n\n.footer_card_main_div > ul {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer_link {\n  list-style: none;\n  margin-top: 12px;\n\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  cursor: pointer;\n}\n\n.footer_social_icons {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.footer_social_icon {\n  width: 40px;\n  height: 40px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n \n  .footer_main_container {\n    max-width: 100%;\n    flex-direction: row;\n    padding: 40px 0 40px 50px;\n  }\n  \n  .footer_left {\n    height: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  \n  .footer_logo {\n    width: 300px;\n    height: 50px;\n  }\n  \n  .footer_right {\n      flex-direction: row;\n      padding: 0 0 0 100px;\n  }\n  \n  .footer_card {\n    width: 180px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding: 0 30px 40px 0;\n  }\n  \n  .footer_card_heading_div {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  \n  .footer_card_heading_div > p {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n  \n  .footer_card_main_div > ul {\n      flex-direction: column;\n  }\n  \n  .footer_link {\n    margin-top: 12px;\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n \n  .footer_main_container {\n    max-width: 100%;\n    flex-direction: row;\n    padding: 40px 0 40px 20px;\n  }\n  \n  .footer_left {\n    display: none;\n    height: 100%;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  \n  .footer_logo {\n    width: 300px;\n    height: 50px;\n  }\n  \n  .footer_right {\n      flex-direction: row;\n      padding: 0 0 0 70px;\n  }\n  \n  .footer_card {\n    width: 180px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding: 0 30px 40px 0;\n  }\n  \n  .footer_card_heading_div {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  \n  .footer_card_heading_div > p {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n  \n  .footer_card_main_div > ul {\n      flex-direction: column;\n  }\n  \n  .footer_link {\n    margin-top: 12px;\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n \n  .footer_main_container {\n    max-width: 100%;\n    flex-direction: column;\n    padding: 40px 0 0px 20px;\n  }\n  \n  /* .footer_left {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 30px;\n  }\n  \n  .footer_logo {\n    width: 300px;\n    height: 50px;\n  } */\n  \n  .footer_right {\n      flex-direction: row;\n      padding: 0 0 0 30px;\n  }\n  \n  .footer_card {\n    width: 180px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding: 0 30px 40px 0;\n  }\n  \n  .footer_card_heading_div {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  \n  .footer_card_heading_div > p {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n  \n  .footer_card_main_div > ul {\n      flex-direction: column;\n  }\n  \n  .footer_link {\n    margin-top: 12px;\n    font-size: 16px;\n  }\n  \n  .footer_social_icon {\n    width: 35px;\n    height: 35px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .footer_wrapper {\n    margin-top: 30px;\n  }\n \n  .footer_main_container {\n    max-width: 100%;\n    flex-direction: column;\n    padding: 20px 0 0px 20px;\n  }\n  \n  /* .footer_left {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n  }\n  \n  .footer_logo {\n    width: 300px;\n    height: 50px;\n  } */\n  \n  .footer_right {\n      flex-direction: row;\n      padding: 0 0 20px 0;\n      flex-wrap: wrap;\n  }\n  \n  .footer_card {\n    width: 100%;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding: 0 0px 20px 0;\n  }\n  \n  .footer_card_heading_div {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  \n  .footer_card_heading_div > p {\n    font-size: 18px;\n    margin-bottom: 12px;\n  }\n\n  .footer_card_main_div {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  \n  .footer_card_main_div > ul {\n      flex-direction: row;\n      flex-wrap: wrap;\n  }\n  \n  .footer_link {\n    width: auto;\n    margin-top: 8px;\n    font-size: 14px;\n    padding: 0 10px 0 0;\n    margin: 0 10px 5px 0;\n    border-right: 1px solid black;\n    word-break:keep-all;\n  }\n\n  .footer_link:last-child {\n    border-right: none;\n  }\n  \n  .footer_social_icon {\n    width: 30px;\n    height: 30px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
